import { IState } from "../../../../../types";
import { useSelector } from "react-redux";
import { ICustomComponentConfig, IDashboardComponent } from "../../../types";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from "@mui/material";
import { ReactElement } from "react";

const customComponents: Record<string, { value: string, text: string, }[]> = {
  "EAF":  [ { value: "Temperature", text: "Temperature" }, { value: "Oxygen", text: "Oxygen" } ]
};

interface IProps {
  component: IDashboardComponent<ICustomComponentConfig>;
  updateComponent: (component: IDashboardComponent<ICustomComponentConfig>) => void;
}


const CustomComponentConfig = ({ component, updateComponent }: IProps): ReactElement => {
  const selectedNode = useSelector((state: IState) => state.selectedNode);
  const zoneComponentList = customComponents[selectedNode.code] ?? [];

  const onChange = (_field: keyof ICustomComponentConfig, value: string) => {
    component.config.code = value;
    updateComponent({ ...component });
  };

  return (
    <FormControl className="m-2" >
      <InputLabel sx={{ transform: "translate(0px, 0px) scale(0.75) !important" }}>Component Type</InputLabel>
      <Select
        variant="standard"
        value={component.config.code ?? "NONE"}
        displayEmpty={true}
        onChange={(event) => onChange("code", event.target.value)}
        style={{ width: 200 }}>
        <MenuItem value="NONE">NONE</MenuItem>
        { zoneComponentList.map(item => {

          return (
            <MenuItem key={`custom-${item.value}`} value={item.value}>{item.text}</MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};


export default CustomComponentConfig;